import { Link } from "react-router-dom";
import { allCategories } from "@/utils/comics";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 pb-24 pt-12 text-background-100 md:pb-12">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-12">
          <div className="col-span-2 lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-extrabold tracking-tight text-background-50">
                JMComic
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              JMComic 漫画频道聚合热血、恋爱、奇幻、都市、悬疑、校园、科幻、古风等题材，
              为漫画爱好者提供清晰的分类浏览、详细的漫画资料与最新连载动态。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full border border-background-700 px-3 py-1 text-[11px] text-background-300">
                精选漫画
              </span>
              <span className="rounded-full border border-background-700 px-3 py-1 text-[11px] text-background-300">
                每日更新
              </span>
              <span className="rounded-full border border-background-700 px-3 py-1 text-[11px] text-background-300">
                题材齐全
              </span>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50">漫画分类</h4>
            <ul className="mt-3 space-y-2 text-sm text-background-300">
              {allCategories.slice(0, 5).map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="transition-colors hover:text-primary-300"
                  >
                    {category.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50">更多分类</h4>
            <ul className="mt-3 space-y-2 text-sm text-background-300">
              {allCategories.slice(5).map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="transition-colors hover:text-primary-300"
                  >
                    {category.name}漫画
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/category/all" className="transition-colors hover:text-primary-300">
                  全部漫画
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-background-50">站内导航</h4>
            <ul className="mt-3 space-y-2 text-sm text-background-300">
              <li>
                <Link to="/" className="transition-colors hover:text-primary-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/updates" className="transition-colors hover:text-primary-300">
                  最新连载更新
                </Link>
              </li>
              <li>
                <Link to="/search" className="transition-colors hover:text-primary-300">
                  搜索漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-300">
                  关于我们 / 反馈
                </Link>
              </li>
            </ul>
            <p className="mt-4 text-xs leading-relaxed text-background-400">
              本站漫画信息与封面均为演示内容，仅用于产品展示。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 JMComic 漫画频道 · 保留所有权利</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-primary-300">
              用户须知
            </Link>
            <Link to="/about" className="transition-colors hover:text-primary-300">
              版权声明
            </Link>
            <Link to="/about" className="transition-colors hover:text-primary-300">
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}